
import type { PropOptions } from 'vue';
import Vue from 'vue';
import AutocompleteDropdownV2 from '@/components/common/AutocompleteDropdownV2.vue';
import CloseIcon from '@/assets/svg/close.vue.svg';
import type { City } from '@/types/graphql';
import type { ILocation } from '@/components/partials/jobs/JobsBasicInformation/JobsBasicInformationCity/types';

interface IData {
  cities: Array<ILocation>;
  query: string;
  selectedCityId: null | number;
  currentCityId: null | number;
}

interface IAutocompleteResult {
  label: string;
  value: number;
  text: string;
}

const getStringLocation = (city: City): string => {
  const { name, stateCode, countryName } = city;

  return [name, stateCode, countryName].filter(Boolean).join(', ');
};

export default Vue.extend({
  name: 'JobsDesiredCriteriaModalFormCityAutocomplete',
  components: {
    AutocompleteDropdownV2,
    CloseIcon,
  },
  props: {
    currentCity: {
      type: [Object, null],
      default: null,
    } as PropOptions<City>,
  },
  data(): IData {
    return {
      cities: [],
      query: this.currentCity?.name ? getStringLocation(this.currentCity) : '',
      selectedCityId: this.currentCity?.name ? Number(this.currentCity.id) : null,
      currentCityId: this.currentCity?.name ? Number(this.currentCity.id) : null,
    };
  },
  methods: {
    async onQuery(item: IAutocompleteResult): Promise<void> {
      this.cities = await this.getItems(item.text);
      if (this.selectedCityId && this.currentCityId !== this.selectedCityId) {
        this.selectedCityId = null;
        this.$emit('submit', null);
      }
    },
    onPush(item: IAutocompleteResult): void {
      this.selectedCityId = item.value;
      this.query = item.label;
      // @ts-ignore
      this.$refs.input.focusInput();
      this.handleSubmit();
    },
    async getItems(term: string): Promise<Array<ILocation>> {
      try {
        const { result } = await this.$api.$get('/cities/autocomplete.json', {
          params: { term },
        });

        return result;
      } catch (e) {
        this.$sentryUtils.error(e);

        return [];
      }
    },
    resetQuery(): void {
      this.query = '';
      this.selectedCityId = null;
      this.$emit('submit', null);
    },
    handleSubmit(): void {
      this.$emit('submit', Number(this.selectedCityId));
    },
    focus() {
      // @ts-ignore
      this.$refs.input.focusInput();
    },
  },
});
